import {type FC, memo} from 'react';

import NiceModal, {useModal} from '@ebay/nice-modal-react';

import {useI18n} from '@yourcoach/i18n';

import type {Props as ModalProps} from '@src/components/ModalNew';

import Modal from '@src/components/ModalNew';

import type {Props as CRUGoalProps} from './CRUGoal';

import {CRUGoal} from './CRUGoal';

type Props = Partial<ModalProps> & CRUGoalProps;

const CRUGoalModal: FC<Props> = ({
  children,
  courseId,
  goal,
  onAfterCreateCb,
  onAfterUpdateCb,
  onSuccess,
  programId,
  ...modalProps
}) => {
  const {t} = useI18n();

  return (
    <Modal
      {...modalProps}
      title={
        goal ? t('web-app:CRUGoal.edit_title') : t('web-app:CRUGoal.title')
      }
    >
      <CRUGoal
        courseId={courseId}
        goal={goal}
        onAfterCreateCb={onAfterCreateCb}
        onAfterUpdateCb={onAfterUpdateCb}
        onSuccess={onSuccess}
        programId={programId}
      />
      {children}
    </Modal>
  );
};

const CRUGoalNiceModal = NiceModal.create<Props>(
  ({
    courseId,
    goal,
    onAfterCreateCb,
    onAfterUpdateCb,
    onSuccess,
    programId,
  }) => {
    const modal = useModal();

    return (
      <CRUGoalModal
        courseId={courseId}
        goal={goal}
        isOpen={modal.visible}
        onAfterClose={modal.remove}
        onAfterCreateCb={() => {
          modal.hide();
          onAfterCreateCb?.();
        }}
        onAfterUpdateCb={() => {
          modal.hide();
          onAfterUpdateCb?.();
        }}
        onRequestClose={modal.hide}
        onSuccess={
          onSuccess
            ? goal => {
                onSuccess(goal);
                modal.hide();
              }
            : undefined
        }
        programId={programId}
      />
    );
  },
);

export {CRUGoalNiceModal};

export default memo(CRUGoalModal);
